var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgPacked(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 16,
    height: 13,
    viewBox: "0 0 16 13",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M6.125 0.5H2.79688C2.30469 0.5 1.88281 0.828125 1.74219 1.27344L0.546875 4.83594C0.523438 4.88281 0.523438 4.95312 0.523438 5H6.125V0.5ZM11.6328 2.42188L11.2344 1.27344C11.0938 0.828125 10.6719 0.5 10.1797 0.5H6.875V4.20312C7.88281 3.07812 9.35938 2.375 11 2.375C11.2109 2.375 11.4219 2.39844 11.6328 2.42188ZM5.375 8C5.375 7.20312 5.53906 6.45312 5.84375 5.75H0.5V11.375C0.5 12.0078 0.992188 12.5 1.625 12.5H7.625C6.26562 11.4922 5.375 9.85156 5.375 8ZM11 3.5C8.51562 3.5 6.5 5.51562 6.5 8C6.5 10.4844 8.51562 12.5 11 12.5C13.4844 12.5 15.5 10.4844 15.5 8C15.5 5.51562 13.4844 3.5 11 3.5ZM13.6719 6.96875L10.6016 10.0156C10.4844 10.1328 10.3203 10.1328 10.2266 10.0156L8.44531 8.23438C8.35156 8.14062 8.35156 7.97656 8.44531 7.85938L9.05469 7.25C9.17188 7.15625 9.33594 7.15625 9.42969 7.27344L10.4141 8.25781L12.6875 6.00781C12.8047 5.89062 12.9688 5.89062 13.0625 6.00781L13.6719 6.61719C13.7656 6.71094 13.7656 6.875 13.6719 6.96875Z",
    fill: "#1A86E0"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgPacked);
export default __webpack_public_path__ + "static/media/packed.01ee1d65.svg";
export { ForwardRef as ReactComponent };